import React from "react";

const MyLibraryLayout = ({ children }) => {
	return (
		<div>
			<div>{children}</div>
		</div>
	);
};

export default MyLibraryLayout;
